<template>
    <div>
        <div class="register-container full-height sm-p-t-30 m-t-80">
      <div class="d-flex justify-content-center flex-column full-height ">
        <!--<div class="headerBG">
          <div class="abs-logo">
            <img src="assets/img/custom/high-res-logo.png" width="180" />
          </div>
        </div>-->

        <div class="spaceC text-center" style="display: ;">
          <h5 class="text-success no-margin">
            This site has a payment module and for security reason <br />
            its cannot run on <strong>Internet explorer </strong> <br />
            Upgrade to edge for ease of use
          </h5>
          <img :src="'/static/img/custom/no-ie.svg'" width="100%" />
          <!-- <form>
            <button
              type="submit"
              class="btn btn-primary btn-cons"
              onclick="location.href = 'buy-stamps.html';"
            >
              Proceed to my account
            </button>
          </form>-->
        </div>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    
}
</script>